import { AdvancedPlatformsActions } from './advanced-platforms.action';

export interface IPlatformsState {
  list: any[];
  pendingList: boolean;
  listError: Error;

  pendingSubscribe: boolean;
  subscribeError: Error;

  pendingUnsubscribe: boolean;
  unSubscribeError: Error;

  isBuyPlatform: boolean;
  isSetSubscribeError: boolean;
}

export const initialState: IPlatformsState = {
  list: [],
  pendingList: false,
  listError: null,

  pendingSubscribe: false,
  subscribeError: null,

  pendingUnsubscribe: false,
  unSubscribeError: null,

  isBuyPlatform: false,
  isSetSubscribeError: false,
};

export function AdvancedPlatformsReducer(
  state: IPlatformsState = initialState,
  action: AdvancedPlatformsActions,
) {
  switch (action.type) {
    // Platforms
    case AdvancedPlatformsActions.getPlatforms:
      return { ...state, pendingList: true, listError: null };

    case AdvancedPlatformsActions.getPlatformsSuccess:
      return {
        ...state,
        list: action.payload,
        pendingList: false,
        listError: null,
      };

    case AdvancedPlatformsActions.getPlatformsError:
      return { ...state, pendingList: false, listError: action.payload };
      
    // Subscribe GET
    case AdvancedPlatformsActions.getSubscribes:
      return { ...state, pendingSubscribe: true, subscribeError: null };

    case AdvancedPlatformsActions.getSubscribesSuccess: {
      const list = [...state.list];

      action.payload.forEach((pay) => {
        list.forEach((platform, i) => {
          if (pay.platformId === platform.id)
            list[i].subscriptionStatus = pay.status;
        });
      });

      return { ...state, list, pendingSubscribe: false, subscribeError: null };
    }

    case AdvancedPlatformsActions.getSubscribesError:
      return {
        ...state,
        pendingSubscribe: false,
        subscribeError: action.payload,
      };

    default:
      return state;
  }
}
